import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "map"

  connect() {
    super.connect()

    const stopsJson = this.bridgeElement.bridgeAttribute("stops")
    if (!stopsJson) return

    const stops = JSON.parse(stopsJson)
    this.send("connect", { stops }, (message) => {
      if (message.data?.action === "scrollTo") {
        this.#scrollToStop(message.data.position)
      }
    })
  }

  #scrollToStop(position) {
    const el = document.getElementById(`stop_${position}`)
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }
}
